import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectDetails} from '~/CreateFabricInvitation/reducers/details/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {TextEditor} from '~library/organisms/TextEditor';

export const HostMessage = () => {
  const dispatch = useDispatch();
  const {notes = ''} = useSelector(selectDetails);

  const updateValue = useCallback(
    (value: string) => {
      dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {notes: value},
      });
    },
    [dispatch]
  );

  return (
    <TextEditor
      minRows={5}
      value={notes}
      onChange={updateValue}
      data-qa-id="edit-eventhostnote"
      id="host-message"
      maxLength={5000}
      placeholder="Optional: Add a note to your guests."
      toolbarId="host-message-toolbar"
      containerClassName="details-fields__host-message-input"
    />
  );
};
